"use strict";
var ko = require("knockout");
var $ = require("jquery");
var _ = require("lodash");
var browserUtils_1 = require("../../app/utils/browserUtils");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var scriptjs = require("scriptjs");
var typograf = require('typograf');
var destroy = function (element) {
    var $el = $(element);
    return function () {
        if ($el.data("froala.editor")) {
            $el.froalaEditor("destroy");
        }
    };
};
var loadFroala = function (onLoad) {
    if ($.FroalaEditor) {
        onLoad();
        return;
    }
    var cssAnchor = $("#dynamicCss")[0];
    ajaxUtils_1.AjaxUtils.loadCss("distMobile/vendor/froala-wysiwyg-editor/css/froala.min.css?v=03102017", cssAnchor);
    scriptjs(ajaxUtils_1.AjaxUtils.getFullUrl("distCommon/vendor/froala-wysiwyg-editor/js/froala_editor.min.js?v=03102017"), function () {
        scriptjs(ajaxUtils_1.AjaxUtils.getFullUrl("distMobile/vendor/froala-wysiwyg-editor/js/plugins.min.js?v=03102017"), function () {
            $.FroalaEditor.DefineIcon("quote", { NAME: "quote-left" });
            $.FroalaEditor.RegisterShortcut($.FE.KEYCODE.SINGLE_QUOTE, "quote", "decrease", "'", !0);
            $.FroalaEditor.RegisterCommand("quote", {
                title: "Цитата",
                focus: false,
                undo: false,
                refreshAfterCallback: false,
                callback: function () {
                    var self = this;
                    var i, blocks = this.selection.blocks();
                    var isBlockquote = false;
                    this.selection.save();
                    for (i = 0; i < blocks.length; i++) {
                        var blockquote = $(blocks[i]).parentsUntil(this.$el, "BLOCKQUOTE")[0];
                        if (blocks[i].tagName !== "BLOCKQUOTE" && blockquote) {
                            isBlockquote = true;
                            $(blockquote).replaceWith(blockquote.innerHTML);
                        }
                    }
                    if (!isBlockquote) {
                        var $blockquote = $("<blockquote>");
                        $blockquote.insertBefore(blocks[0]);
                        for (i = 0; i < blocks.length; i++) {
                            $blockquote.append(blocks[i]);
                        }
                    }
                    this.html.unwrap(), this.selection.restore();
                }
            });
            $.FroalaEditor.DefineIconTemplate("custom-icons", "<i class='icon-[NAME]'></i>");
            $.FroalaEditor.ICON_DEFAULT_TEMPLATE = "custom-icons";
            $.FroalaEditor.DefineIcon("typograf", { NAME: "paragraph" });
            $.FroalaEditor.RegisterCommand("typograf", {
                title: "Оттипографить",
                focus: false,
                undo: true,
                refreshAfterCallback: true,
                callback: function () {
                    var _this = this;
                    var html = this.html.getSelected();
                    if (!html || !html.length)
                        return;
                    ajaxUtils_1.AjaxUtils.get("utils/gettypograftype", {}).done(function (result) {
                        if (!result.isSuccessful) {
                            alert(result.messages[0]);
                            return;
                        }
                        var typografType = result.data;
                        switch (typografType) {
                            case "lebedev": {
                                _this.undo.saveStep();
                                ajaxUtils_1.AjaxUtils.post("utils/typograf", { text: html }).done(function (result) {
                                    if (!result.isSuccessful) {
                                        alert(result.messages[0]);
                                        return;
                                    }
                                    _this.html.insert(result.data);
                                    _this.undo.saveStep();
                                    _this.events.focus();
                                    setTimeout(function () {
                                        _this.cursor.backspace();
                                    }, 0);
                                });
                                break;
                            }
                            default: {
                                var tp = new typograf({ locale: ['ru', 'en-US'] });
                                var newText = tp.execute(html);
                                _this.html.insert(newText);
                                _this.undo.saveStep();
                                _this.events.focus();
                            }
                        }
                    });
                }
            });
            // Define popup template.
            $.extend($.FroalaEditor.POPUP_TEMPLATES, {
                "spoilerPlugin.popup": "[_FORM_]"
            });
            $.FroalaEditor.PLUGINS.spoilerPlugin = function (editor) {
                // Create custom popup.
                function initPopup() {
                    var formHtml = "<div class='fr-spoiler-layer fr-layer fr-active'>";
                    formHtml += "<div class='fr-input-line'><input name='title' value='спойлер (показать)' type='text' " +
                        "placeholder='Название кнопки' tabIndex='1' class='fr-not-empty'><label>Название кнопки</label></div>";
                    formHtml += "</div>";
                    formHtml += "<div class='fr-action-buttons'>" +
                        "<button class='fr-command fr-submit' data-cmd='spoilerInsert' href='#' tabIndex=2 type='button'>Вставить" +
                        "</button></div></div>";
                    // Load popup template.
                    var template = {
                        form: formHtml
                    };
                    // Create popup.
                    var $popup = editor.popups.create("spoilerPlugin.popup", template);
                    return $popup;
                }
                // Show the popup
                function showPopup() {
                    var html = editor.html.getSelected();
                    if (!html || !html.length) {
                        alert("Пожалуйста, выделите текст.");
                        return;
                    }
                    ;
                    // Get the popup object defined above.
                    var $popup = editor.popups.get("spoilerPlugin.popup");
                    // If popup doesn't exist then create it.
                    // To improve performance it is best to create the popup when it is first needed
                    // and not when the editor is initialized.
                    if (!$popup)
                        $popup = initPopup();
                    // Set the editor toolbar as the popup's container.
                    editor.popups.setContainer("spoilerPlugin.popup", editor.$tb);
                    // This will trigger the refresh event assigned to the popup.
                    // editor.popups.refresh('customPlugin.popup');
                    // This custom popup is opened by pressing a button from the editor's toolbar.
                    // Get the button's object in order to place the popup relative to it.
                    var $btn = editor.$tb.find('.fr-command[data-cmd="spoiler"]');
                    // Set the popup's position.
                    var left = $btn.offset().left + $btn.outerWidth() / 2;
                    var top = $btn.offset().top + (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);
                    editor.selection.save();
                    // Show the custom popup.
                    // The button's outerHeight is required in case the popup needs to be displayed above it.
                    editor.popups.show("spoilerPlugin.popup", left, top, $btn.outerHeight());
                }
                // Hide the custom popup.
                function hidePopup() {
                    editor.popups.hide("spoilerPlugin.popup");
                }
                function getPopupTitle() {
                    return editor.popups.get("spoilerPlugin.popup").find("input[name='title']").val();
                }
                // Methods visible outside the plugin.
                return {
                    showPopup: showPopup,
                    hidePopup: hidePopup,
                    getPopupTitle: getPopupTitle
                };
            };
            // Define an icon and command for the button that opens the custom popup.
            $.FroalaEditor.DefineIcon("spoilerIcon", { NAME: "eye-slash" });
            $.FroalaEditor.RegisterCommand("spoiler", {
                title: "Спойлер",
                undo: false,
                focus: false,
                icon: "spoilerIcon",
                plugin: "spoilerPlugin",
                popup: true,
                callback: function () {
                    if (!this.popups.isVisible("spoilerPlugin.popup")) {
                        this.spoilerPlugin.showPopup();
                    }
                    else {
                        if (this.$el.find(".fr-marker")) {
                            this.events.disableBlur();
                            this.selection.restore();
                        }
                        this.popups.hide("spoilerPlugin.popup");
                    }
                }
            });
            $.FroalaEditor.RegisterCommand("spoilerInsert", {
                focus: false,
                refreshAfterCallback: false,
                undo: true,
                callback: function () {
                    var popupTitle = this.spoilerPlugin.getPopupTitle();
                    if (!popupTitle || !popupTitle.length)
                        return;
                    this.selection.restore();
                    var html = this.html.getSelected();
                    this.undo.saveStep();
                    this.spoilerPlugin.hidePopup();
                    this.html.insert("[spoiler=" + popupTitle + "]" + html + "[/spoiler]");
                    this.undo.saveStep();
                    this.events.focus();
                }
            });
            $.FroalaEditor.DefineIcon("paragraphFormat", { NAME: "header" });
            $.FroalaEditor.VIDEO_PROVIDERS = [
                {
                    test_regex: /^.+(?:(?:vk\.ru)|(?:vk\.com)|(?:vkvideo\.ru))\/(?:.+)?((vkvideo)|(video))[^_&]+/,
                    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:(?:vk\.ru)|(?:vk\.com)|(?:vkvideo\.ru))(?:.+)?(?:video)([0-9a-zA-Z_\-]+)_([0-9a-zA-Z_\-]+)%?(?:.*)/g,
                    url_text: "//vk.ru/video_ext.php?oid=$1&id=$2",
                    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
                    provider: "vk"
                },
                {
                    test_regex: /^.+(?:(?:vk\.ru)|(?:vk\.com)|(?:vkvideo\.ru))\/(?:.*clip)(.+)/,
                    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:(?:vk\.ru)|(?:vk\.com)|(?:vkvideo\.ru))\/(?:.*clip)([0-9a-zA-Z_\-]+)_([0-9a-zA-Z]+)(?:.*)/g,
                    url_text: "//vk.ru/video_ext.php?oid=$1&id=$2",
                    html: '<iframe width="325" height="646" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
                    provider: "vk"
                },
                {
                    test_regex: /^.+(yappy.media)\/video?[^_&]+/,
                    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:yappy\.media)\/(?:video)\/([0-9a-zA-Z_\-]+)/g,
                    url_text: "//yappy.media/default/embed/$1",
                    html: '<iframe width="360" height="640" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
                    provider: "yappy"
                },
                {
                    test_regex: /^.+(rutube.ru)(?!\/yappy)(?!\/live)\/[^_&\n]+/,
                    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:rutube\.ru)(?:\/shorts)?(?:\/video)?(?:\/private)?\/([0-9a-zA-Z_\-]+\/\?\S*)?\s*/g,
                    url_text: "//rutube.ru/play/embed/$1",
                    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
                    provider: "rutube"
                },
                {
                    test_regex: /^.*((youtu.be)|(youtube.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))?\??v?=?([^#\&\?]*).*/,
                    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/|shorts\/)?([0-9a-zA-Z_\-]+)(.+)?/g,
                    url_text: "//www.youtube.com/embed/$1",
                    html: '<iframe width="640" height="360" src="{url}?wmode=opaque" frameborder="0" allowfullscreen></iframe>',
                    provider: "youtube"
                },
                {
                    test_regex: /^.*(?:vimeo.com)\/(?:channels(\/\w+\/)?|groups\/*\/videos\/\u200b\d+\/|video\/|)(\d+)(?:$|\/|\?)/,
                    url_regex: /(?:https?:\/\/)?(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i,
                    url_text: "//player.vimeo.com/video/$1",
                    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
                    provider: "vimeo"
                }
            ];
            $.FroalaEditor.VIDEO_EMBED_REGEX = /((<iframe(\n*.)*><\/iframe>)|(<embed.*>))/i;
            onLoad();
        });
    });
};
var getDefaultOptions = function () {
    var rootUrl = window["app"].rootUrl;
    var defaultOptions = {
        language: "ru",
        key: "eQZMe1NJGC1HTMVANU==",
        pluginsEnabled: ["align", "spoilerPlugin", "emoticons", "image", "link", "lists", "video"],
        imageUploadURL: rootUrl + "file/froalaUploadImage",
        imagePaste: false,
        imageUploadMethod: "POST",
        imageMaxSize: 3 * 1024 * 1024,
        linkInsertButtons: ["linkBack"],
        linkEditButtons: ["linkOpen", "linkEdit", "linkRemove"],
        imageEditButtons: [
            "imageReplace", "imageAlign", "imageDisplay",
            "|", "imageLink", "linkOpen", "linkEdit", "linkRemove",
            "-", "imageAlt", "imageSize", "imageRemove"
        ],
        imageDefaultWidth: 0,
        typingTimer: 250,
        htmlAllowComments: false,
        videoDefaultDisplay: "block",
        videoInsertButtons: ["videoBack", "|", "videoByURL", "videoEmbed"],
        wordPasteModal: false,
        wordAllowedStyleProps: ["background", "color", "width", "text-align", "vertical-align", "background-color"],
        htmlAllowedTags: [
            "a", "b", "blockquote", "br",
            "cite", "code", "col", "colgroup", "del", "details",
            "div", "em", "embed", "hr", "i", "iframe", "img", "li",
            "ol", "p", "pre", "small", "span", "strike",
            "strong", "sub", "sup", "table", "dd",
            "tbody", "td", "th", "thead",
            "time", "tr", "u", "ul", "video"
        ],
        toolbarButtons: [
            "bold", "italic", "underline", "strikeThrough", "|",
            "quote", "align", "color", "emoticons", "inlineStyle", "paragraphStyle",
            "paragraphFormat", "formatOL", "formatUL",
            "insertHR",
            "insertLink", "insertImage", "insertVideo", "insertFile", "insertTable",
            "clearFormatting", "fullscreen", "html"
        ],
        toolbarButtonsMD: [
            "bold", "italic", "underline", "strikeThrough", "|",
            "quote", "align", "color", "emoticons", "inlineStyle", "paragraphStyle",
            "paragraphFormat", "formatOL", "formatUL",
            "insertHR",
            "insertLink", "insertImage", "insertVideo", "insertFile", "insertTable",
            "clearFormatting", "fullscreen", "html"
        ],
        toolbarButtonsSM: [
            "bold", "italic", "underline", "strikeThrough", "|", "quote", "spoiler", "insertLink", "insertImage", "insertVideo", "fullscreen", "|",
            "undo", "redo"
        ],
        toolbarButtonsXS: [
            "bold", "|", "quote", "spoiler", "insertLink", "insertImage", "insertVideo", "|", "undo", "redo"
        ],
        emoticonsStep: 7,
        emoticonsSet: [
            { code: "1f642", desc: "Slightly smiling face" },
            { code: "1f600", desc: "Grinning face" },
            { code: "1f602", desc: "Face with tears of joy" },
            { code: "1f605", desc: "Smiling face with open mouth and cold sweat" },
            { code: "1f606", desc: "Smiling face with open mouth and tightly-closed eyes" },
            { code: "1f607", desc: "Smiling face with halo" },
            { code: "1f608", desc: "Smiling face with horns" },
            { code: "1f609", desc: "Winking face" },
            { code: "1f60a", desc: "Smiling face with smiling eyes" },
            { code: "1f60b", desc: "Face savoring delicious food" },
            { code: "1f60d", desc: "Smiling face with heart-shaped eyes" },
            { code: "1f60e", desc: "Smiling face with sunglasses" },
            { code: "1f913", desc: "Nerd face" },
            { code: "1f60f", desc: "Smirking face" },
            { code: "1f610", desc: "Neutral face" },
            { code: "1f612", desc: "Unamused face" },
            { code: "1f613", desc: "Face with cold sweat" },
            { code: "1f614", desc: "Pensive face" },
            { code: "1f615", desc: "Confused face" },
            { code: "1f618", desc: "Face throwing a kiss" },
            { code: "1f917", desc: "hugging face" },
            { code: "1f61d", desc: "Face with stuck out tongue" },
            { code: "1f641", desc: "Slightly frowning face" },
            { code: "1f61e", desc: "Disappointed face" },
            { code: "1f621", desc: "Pouting face" },
            { code: "1f622", desc: "Crying face" },
            { code: "1f623", desc: "Persevering face" },
            { code: "1f625", desc: "Disappointed but relieved face" },
            { code: "1f627", desc: "Anguished face" },
            { code: "1f628", desc: "Fearful face" },
            { code: "1f62a", desc: "Sleepy face" },
            { code: "1f62b", desc: "Tired face" },
            { code: "1f62c", desc: "Grimacing face" },
            { code: "1f62d", desc: "Loudly crying face" },
            { code: "1f62f", desc: "Hushed face" },
            { code: "1f630", desc: "Face with open mouth and cold sweat" },
            { code: "1f631", desc: "Face screaming in fear" },
            { code: "1f632", desc: "Astonished face" },
            { code: "1f633", desc: "Flushed face" },
            { code: "1f634", desc: "Sleeping face" },
            { code: "1f635", desc: "Dizzy face" },
            { code: "1f63a", desc: "Smiling cat face with open mouth" },
            { code: "1f639", desc: "Cat face with tears of joy" },
            { code: "1f63b", desc: "Smiling cat face with heart-eyes" },
            { code: "1f640", desc: "Weary cat face" },
            { code: "1f44d", desc: "Thumbs up sign" },
            { code: "1f44e", desc: "Thumbs down sign" },
            { code: "270c", desc: "Victory hand" },
            { code: "1f91d", desc: "Handshake" },
            { code: "1f37f", desc: "Popcorn" },
            { code: "1f37a", desc: "Beer mug" },
            { code: "1f37b", desc: "Clinking beer mugs" },
            { code: "1f942", desc: "Clinking glasses" },
            { code: "1f379", desc: "Tropical drink" },
            { code: "1f37e", desc: "Bottle with popping cork" },
            { code: "1f370", desc: "Shortcake" },
            { code: "1f382", desc: "Birthday cake" },
            { code: "1f3c6", desc: "Trophy" },
            { code: "1f381", desc: "Wrapped present" },
            { code: "1f389", desc: "Party popper" },
            { code: "2764", desc: "Heart" },
            { code: "1f494", desc: "Broken heart" },
            { code: "1f339", desc: "Rose" },
            { code: "1f490", desc: "Bouquet" },
            { code: "1f31f", desc: "Glowing star" },
            { code: "1f525", desc: "Fire" },
            { code: "1f648", desc: "See-no-evil monkey" },
            { code: "1f649", desc: "Hear-no-evil monkey" },
            { code: "1f64a", desc: "Speak-no-evil monkey" },
            { code: "1f43a", desc: "Wolf face" },
            { code: "1f984", desc: "Unicorn face" },
            { code: "1f40c", desc: "Snail" }
        ]
    };
    return defaultOptions;
};
ko.bindingHandlers["froala"] = {
    init: function (element, value, bindings) {
        var $el = $(element);
        $el.hide();
        loadFroala(function () {
            var model = value();
            var allBindings = ko.unwrap(bindings());
            var options = ko.toJS(allBindings.froalaOptions) || {};
            if (model.isModified) {
                var text = $el.val() || "";
                model(text);
                setTimeout(function () {
                    model.isModified(false);
                }, 50);
            }
            options = _.defaults(options, getDefaultOptions());
            // initialize the editor
            $el.froalaEditor(options);
            var editor = $el.data("froala.editor");
            //$el.on("froalaEditor.focus", function (e, editor) {
            //    $el.siblings(".fr-box").addClass("focused");
            //});
            //$el.on("froalaEditor.blur", function (e, editor) {
            //    $el.siblings(".fr-box").removeClass("focused");
            //});
            // provide froala editor instance for flexibility
            if (allBindings.froalaInstance && ko.isWriteableObservable(allBindings.froalaInstance)) {
                allBindings.froalaInstance($el.data(editor));
            }
            // update underlying model whenever editor content changed
            $el.on("froalaEditor.contentChanged", function (e, editor) {
                if (ko.isWriteableObservable(model)) {
                    var editorValue = editor.html.get();
                    var current = model();
                    if (current !== editorValue) {
                        model(editorValue);
                    }
                }
            });
            // Грязный хак чтобы работало обновление в мобильных браузерах
            var interval;
            if (browserUtils_1.default.isMobile()) {
                interval = setInterval(function () {
                    var editorValue = editor.html.get();
                    var current = model();
                    if (current !== editorValue) {
                        model(editorValue);
                    }
                }, 1000);
            }
            // cleanup editor, when dom node is removed
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                destroy(element);
                if (interval) {
                    try {
                        clearInterval(interval);
                    }
                    catch (e) {
                    }
                }
            });
            var unsupportedVideoUrlRegex = /dzen.ru/;
            $el.on("froalaEditor.video.linkError", function (ev, el, url) {
                var alertText = unsupportedVideoUrlRegex.test(url)
                    ? 'Вставить по ссылке нельзя. Используйте вариант "Вставить как код"'
                    : 'Данный видеосервис не поддерживается';
                alert(alertText);
            });
        });
        // do not handle child nodes
        return { controlsDescendantBindings: true };
    },
    update: function (element, value) {
        var $el = $(element);
        var modelValue = ko.unwrap(value());
        var editorInstance = $el.data("froala.editor");
        if (editorInstance == null) {
            return;
        }
        var editorValue = editorInstance.html.get();
        // avoid any un-necessary updates
        if (editorValue !== modelValue && (typeof modelValue === "string" || modelValue === null)) {
            editorInstance.html.set(modelValue);
        }
    }
};
//# sourceMappingURL=ko.froala.js.map